import { Component, OnInit } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-start-end-date',
  templateUrl: './start-end-date.component.html',
  styleUrls: ['./start-end-date.component.css']
})
export class StartEndDateComponent implements OnInit {
  startDate: any = moment().subtract(7, "days").format("YYYY-MM-DD");
  endDate: any = moment().format("YYYY-MM-DD");

  constructor() { }

  ngOnInit() {
  }

  loadData() {
    
  }

}
